import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { css } from '@bd/bdui-styles/emotion';
import { withRouter } from 'react-router-dom';
import { Slugify } from '@bd/bdcore-utilities';
// import { Link } from '@bd/bdcore-named-routes';

import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import SpecialResults from './SpecialResults';
import { colors } from '../../styles';


const styles = css`
  .SpecialOffers_btnWrapper {
    width: 100%;
    text-align: center;
    position:relative;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0px;
    z-index: 1;
    position: sticky;
    width: 100%;
    @media (min-width: 992px) {
      margin-top: -48px;
    }
    .SpecialOffers_btn {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      font-weight: 900;
      position: relative;
      background-color: ${colors.brand3};
      font-size: 14px;
      color: ${colors.white};
      letter-spacing: 1.5px;
      line-height: 19px;
      transition: all .3s ease-out;
      @media(min-width: 992px) {
        max-width: 410px;
      }
      &:hover {
        background-color: ${colors.brand2};
      }
    }
  }
`;

class SpecialOffers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      special: null,
    };
  }
  componentDidMount() {
    const { match } = this.props;
    this.findEvent(get(match, 'params.title'));
  }
  findEvent = param => {
    const special = get(this.props.page, 'special').find(item => Slugify(get(item, 'headline')) === param);
    this.setState({ special });
  }
  render() {
    const { special } = this.state;
    const { page } = this.props;
    if (!special) {
      return null;
    }
    const pageTitle = get(special, 'short_headline') ? get(special, 'short_headline') : get(special, 'headline').slice(0, 30).concat('...');
    return (
      <PageWrapper className={styles}>
        <PageHelmet page={page} />
        <InsideHeader
          h1={`${pageTitle}`}
          background={get(page, 'page_image.contentUrl')}
        />
        <SpecialResults special={special} />
      </PageWrapper>
    );
  }
}

SpecialOffers.propTypes = {
  page: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default withData({
  page: 'special_offers',
})(withRouter(SpecialOffers));



// WEBPACK FOOTER //
// ./src/pages/SpecialOffersDetail/index.js